
import React, { Component } from 'react';
import Highcharts from 'highcharts'
import variablePie from "highcharts/modules/variable-pie.js";
variablePie(Highcharts);

function renderIcons() {

    // Move icon
    if (!this.series[0].icon) {
        this.series[0].icon = this.renderer.path(['M', -8, 0, 'L', 8, 0, 'M', 0, -8, 'L', 8, 0, 0, 8])
            .attr({
                stroke: '#303030',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
                'stroke-width': 2,
                zIndex: 10
            })
            .add(this.series[2].group);
    }
    this.series[0].icon.translate(
        this.chartWidth / 2 - 10,
        this.plotHeight / 2 - this.series[0].points[0].shapeArgs.innerR -
        (this.series[0].points[0].shapeArgs.r - this.series[0].points[0].shapeArgs.innerR) / 2
    );

    // Exercise icon
    if (!this.series[1].icon) {
        this.series[1].icon = this.renderer.path(
            ['M', -8, 0, 'L', 8, 0, 'M', 0, -8, 'L', 8, 0, 0, 8,
                'M', 8, -8, 'L', 16, 0, 8, 8]
        )
            .attr({
                stroke: '#ffffff',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
                'stroke-width': 2,
                zIndex: 10
            })
            .add(this.series[2].group);
    }
    this.series[1].icon.translate(
        this.chartWidth / 2 - 10,
        this.plotHeight / 2 - this.series[1].points[0].shapeArgs.innerR -
        (this.series[1].points[0].shapeArgs.r - this.series[1].points[0].shapeArgs.innerR) / 2
    );

    // Stand icon
    if (!this.series[2].icon) {
        this.series[2].icon = this.renderer.path(['M', 0, 8, 'L', 0, -8, 'M', -8, 0, 'L', 0, -8, 8, 0])
            .attr({
                stroke: '#303030',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
                'stroke-width': 2,
                zIndex: 10
            })
            .add(this.series[2].group);
    }

    this.series[2].icon.translate(
        this.chartWidth / 2 - 10,
        this.plotHeight / 2 - this.series[2].points[0].shapeArgs.innerR -
        (this.series[2].points[0].shapeArgs.r - this.series[2].points[0].shapeArgs.innerR) / 2
    );
    // Stand icon
    if (!this.series[3].icon) {
        this.series[3].icon = this.renderer.path(['M', 0, 8, 'L', 0, -8, 'M', -8, 0, 'L', 0, -8, 8, 0])
            .attr({
                stroke: '#ffffff',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
                'stroke-width': 2,
                zIndex: 10
            })
            .add(this.series[3].group);
    }

    this.series[3].icon.translate(
        this.chartWidth / 2 - 10,
        this.plotHeight / 2 - this.series[3].points[0].shapeArgs.innerR -
        (this.series[3].points[0].shapeArgs.r - this.series[3].points[0].shapeArgs.innerR) / 2
    );
}
class Chart1 extends Component {
    constructor() {
        super();
    }
    componentDidMount() {
        // Highcharts.chart('_chart_2_1', {

        //     chart: {
        //         type: 'solidgauge',
        //         height: '110%',
        //         events: {
        //             // render: renderIcons
        //         }
        //     },

        //     title: {
        //         text: 'Average-OS',
        //         style: {
        //             fontSize: '24px'
        //         }
        //     },

        //     tooltip: {
        //         borderWidth: 0,
        //         backgroundColor: 'none',
        //         shadow: false,
        //         style: {
        //             fontSize: '16px'
        //         },
        //         // valueSuffix: '%',
        //         pointFormat: '{series.name}<br><span style="font-size:2em; color: {}; font-weight: bold">{point.y}</span>',
        //         positioner: function (labelWidth) {
        //             return {
        //                 x: (this.chart.chartWidth - labelWidth) / 2,
        //                 y: (this.chart.plotHeight / 2) + 15
        //             };
        //         }
        //     },

        //     pane: {
        //         startAngle: 0,
        //         endAngle: 360,
        //         background: [
        //             { // Track for Stand
        //                 outerRadius: '37%',
        //                 innerRadius: '18%',
        //                 backgroundColor: Highcharts.color(Highcharts.getOptions().colors[3])
        //                     .setOpacity(0.3)
        //                     .get(),
        //                 borderWidth: 0
        //             },
        //             { // Track for Move
        //                 outerRadius: '112%',
        //                 innerRadius: '88%',
        //                 backgroundColor: Highcharts.color(Highcharts.getOptions().colors[0])
        //                     .setOpacity(0.3)
        //                     .get(),
        //                 borderWidth: 0
        //             }, { // Track for Exercise
        //                 outerRadius: '87%',
        //                 innerRadius: '63%',
        //                 backgroundColor: Highcharts.color(Highcharts.getOptions().colors[1])
        //                     .setOpacity(0.3)
        //                     .get(),
        //                 borderWidth: 0
        //             }, { // Track for Stand
        //                 outerRadius: '62%',
        //                 innerRadius: '38%',
        //                 backgroundColor: Highcharts.color(Highcharts.getOptions().colors[2])
        //                     .setOpacity(0.3)
        //                     .get(),
        //                 borderWidth: 0
        //             }]
        //     },
        //     yAxis: {
        //         min: 0,
        //         max: 10,
        //         lineWidth: 0,
        //         tickPositions: []
        //     },

        //     plotOptions: {
        //         solidgauge: {
        //             dataLabels: {
        //                 enabled: false
        //             },
        //             linecap: 'round',
        //             stickyTracking: false,
        //             rounded: true
        //         },
        //         series: {
        //             point: {
        //                 events: {
        //                     click: (e) => this.handleClickChart(e, {}, {})
        //                 }
        //             }
        //         }
        //     },
        //     legend: {
        //         labelFormatter: function () {
        //             return '<span style="text-weight:bold;color:' + Highcharts.getOptions().colors[this.name.indexOf("Quarter 1") != -1 ? 3 : this.name.indexOf("Quarter 2") != -1 ? 0 : this.name.indexOf("Quarter 3") != -1 ? 1 : 2] + '">' + this.name + '</span>';
        //         },
        //         // symbolWidth: 0
        //     },
        //     series: [
        //         {
        //             name: 'Quarter 1/FY21 ( N:' + this.props.chart_1_data.qtr1_n + " )",
        //             data: [{
        //                 color: Highcharts.getOptions().colors[3],
        //                 radius: '37%',
        //                 innerRadius: '18%',
        //                 y: this.props.chart_1_data.qtr1 || 0.00
        //             }],
        //             showInLegend: true
        //         }
        //         , {
        //             name: 'Quarter 2/FY21 ( N:' + this.props.chart_1_data.qtr2_n + " )",
        //             data: [{
        //                 color: Highcharts.getOptions().colors[0],
        //                 radius: '112%',
        //                 innerRadius: '88%',
        //                 y: this.props.chart_1_data.qtr2 || 0.00
        //             }],
        //             showInLegend: true
        //         }, {
        //             name: 'Quarter 3/FY21 ( N:' + this.props.chart_1_data.qtr3_n + " )",
        //             data: [{
        //                 color: Highcharts.getOptions().colors[1],
        //                 radius: '87%',
        //                 innerRadius: '63%',
        //                 y: this.props.chart_1_data.qtr3 || 0.00
        //             }],
        //             showInLegend: true
        //         }, {
        //             name: 'Quarter 4/FY21 ( N:' + this.props.chart_1_data.qtr4_n + " )",
        //             data: [{
        //                 color: Highcharts.getOptions().colors[2],
        //                 radius: '62%',
        //                 innerRadius: '38%',
        //                 y: this.props.chart_1_data.qtr4 || 0.00
        //             }],
        //             showInLegend: true
        //         }]
        // });

        Highcharts.chart('chart_2_1', {
            colors: ['#FFD700', '#C0C0C0', '#CD7F32'],
            chart: {
                type: 'column',
                inverted: true,
                polar: true
            },
            title: {
                text: 'AVG Nationwide'
            },
            tooltip: {
                outside: true
            },
            pane: {
                size: '85%',
                innerSize: '20%',
                endAngle: 270
            },
            xAxis: {
                tickInterval: 1,
                labels: {
                    align: 'right',
                    useHTML: true,
                    allowOverlap: true,
                    step: 1,
                    y: 3,
                    style: {
                        fontSize: '13px'
                    }
                },
                lineWidth: 0,
                categories: [
                    '2/FY21 ' + '( N:' + this.props.chart_1_data.qtr2_n + " )" + '<span class="f16"><span id="flag" class="flag no">' +
                    '</span></span>',
                    '3/FY21 ' + '( N:' + this.props.chart_1_data.qtr3_n + " )" + '<span class="f16"><span id="flag" class="flag us">' +
                    '</span></span>',
                    '4/FY21 ' + '( N:' + this.props.chart_1_data.qtr4_n + " )" + '<span class="f16"><span id="flag" class="flag de">' +
                    '</span></span>',
                    '1/FY21 ' + '( N:' + this.props.chart_1_data.qtr1_n + " )" + '<span class="f16"><span id="flag" class="flag ca">' +
                    '</span></span>'
                ]
            },
            yAxis: {
                crosshair: {
                    enabled: true,
                    color: '#333'
                },
                max: 10,
                lineWidth: 0,
                tickInterval: 1,
                reversedStacks: false,
                endOnTick: true,
                showLastLabel: true
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    borderWidth: 0,
                    pointPadding: 0,
                    groupPadding: 0.15
                },
                series: {
                    point: {
                        events: {
                            click: (e) => this.handleClickChart(e, {}, {})
                        }
                    }
                }
            },
            series: [{
                name: 'Point',
                data: [this.props.chart_1_data.qtr2 || 0.00, this.props.chart_1_data.qtr3 || 0.00, this.props.chart_1_data.qtr4 || 0.00, this.props.chart_1_data.qtr1 || 0.00]
            },
            ]
        });
    }
    handleClickChart = (e, categories, series) => {
        if (!this.props.callbackChangelevel) return
        this.props.callbackChangelevel({ level: 2, selected: e.point.series._i })
    }
    render() {
        return (
            <div className={"chart-box"}>
                <center>
                    <div id="chart_2_1"
                        style={{ width: "400px", height: "450px" }}
                    ></div>
                </center>
            </div>
        );
    }
}

export default Chart1;